import { Operation } from "../../entity/Operation";
import { OperationDto } from "../dto/Operation.Dto";
import { toDate } from "../../utils/GlobalFunctions";

export const mapToOperation = (operationDto: OperationDto[]): Operation[] => {
  return operationDto.map((operationDto) => {
    return {
      id: operationDto.id,
      quantity: operationDto.quantity,
      productId: operationDto.productId,
      description: operationDto.description,
      amount: operationDto.amount,
      type: operationDto.type,
      date: toDate(operationDto.date),
      storeId: operationDto.storeId,
    };
  });
};
